import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from './views/login/index.vue'
import resetPassword from './views/login/resetPassword.vue'
// import store from './store'

Vue.use(VueRouter)

// 解决重复点击路由报错的BUG
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch((err) => err)
}

const routes = [
    {
        path: '/',
        name: 'login-page',
        component: Login,
    },

    {
        path: '/resetPassword',
        name: 'resetPassword',
        component: resetPassword,
    },
    {
        path: '/student',
        name: 'student-page',
        component: () => import('./views/student/index'),
        redirect: '/taskClass',
        children: [
            {
                path: '/taskClass',
                component: () => import('./views/student/taskClass')
            },
            {
                path: '/classDetail',
                component: () => import('./views/student/classDetail')
            },
            {
                path: '/myEvaluate',
                component: () => import('./views/student/myEvaluate')
            },
            {
                path: '/studentMyInfo',
                component: () => import('./views/student/studentMyInfo')
            },
            {
                path: '/myData',
                component: () => import('./views/student/myData')
            },
            {
                path: '/userInfoDefault',   // 个人资料页面
                component: () => import('./views/student/userInfo.vue')
            },
            {
                path: '/classHours', // 记录课时
                component: () => import('./views/student/classHours.vue')
            }
        ]
    },


    {
        path: '/coach',
        name: 'coach-page',
        component: () => import('./views/coach/index'),
        redirect: '/everyTrain',
        children: [
            {
                path: '/everyTrain',
                component: () => import('./views/coach/everyTrain')
            },
            {
                path: '/taskInfo',
                component: () => import('./views/coach/taskInfo')
            },
            {
                path: '/studentTaskWarp',
                component: () => import('./views/coach/studentTaskWarp')
            },
            {
                path: '/studentTask',
                component: () => import('./views/coach/studentTask')
            },
            {
                path: '/studentEvaluateWarp',
                component: () => import('./views/coach/studentEvaluateWarp')
            },
            {
                path: '/studentEvaluate',
                component: () => import('./views/coach/studentEvaluate')
            },
            {
                path: '/coachMyInfo',
                component: () => import('./views/coach/coachMyInfo')
            },
            {
                path: '/everyTrain',
                component: () => import('./views/coach/everyTrain')
            },
            {
                path: '/studentTask',
                component: () => import('./views/coach/studentTask')
            },
            {
                path: '/studentEvaluate',
                component: () => import('./views/coach/studentEvaluate')
            },
            {
                path: '/addTrain',
                component: () => import('./views/coach/addTrain')
            },
            {
                path: '/addTask',
                component: () => import('./views/coach/addTask')
            },
            {
                path: '/editTask',
                component: () => import('./views/coach/editTask')
            },
            {
                path: '/addStudent',
                component: () => import('./views/coach/addStudent')
            },
            {
                path: '/syncTasks', // 同步任务
                component: () => import('./views/coach/syncTasks')
            },
            {
                path: '/scoreCard', // 积分卡
                component: () => import('./views/coach/scoreCard')
            },


        ]
    },
]
// 定义静态路由集合
// const staticRouterMap = ['home', 'lists', 'detail']

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
})

// 路由全局拦截
// 以下可根据业务逻辑自行在拦截路由中进行处理，此处仅以本人业务作为示例展示
// 本示例以 vuex+sessionStorage相互配合完成动态路由的数据存储
// 仅以vuex存储获取到的动态路由信息后，在刷新页面时，动态路由信息是会丢失，
// 从而导致页面404
// router.beforeEach((to, from, next) => {
//     const userState = JSON.parse(sessionStorage.getItem('userState'))
//     if (!userState || !userState.isLogin) {
//         // 没有登录
//         // 如果前往页面非公共路由，则跳转至首页
//         if (staticRouterMap.indexOf(to.name) < 0) {
//             next({ name: 'home' })
//         } else {
//             next()
//         }
//     } else {
//         // 登录
//         // 已经存在路由列表: 注意刚登陆成功第一次调转route时相应store数据还未更新
//         const hasGetRoute = store.getters['user/hasGetRoute']
//         const routeMap = JSON.parse(sessionStorage.getItem('routeMap'))
//         if (!hasGetRoute && routeMap) {
//             // 刷新页面且有route记录数据，可再次追加动态路由
//             store.dispatch('user/updateRouteOfUser', routeMap)
//             next({ ...to, replace: true })
//         } else {
//             next()
//         }
//     }
// })

export default router
